import dayjs from "dayjs";
import { useMemo } from "react";

const ChatbotWeddingDateProgress = ({weddingDate, createdWedingTimelineDate = new Date()}) => {
  const remainingDays = useMemo(() => {
    const weddingDay = dayjs(weddingDate, 'YYYY-MM-DD').startOf('day');
    const today = dayjs().startOf('day');
    const diffDays = Math.max(weddingDay.diff(today, 'day'), 0);
    return diffDays;
  }, [weddingDate]);

  const totalDays = useMemo(() => {
    const weddingDay = dayjs(weddingDate);
    const createdWedingTimelineDay = dayjs(createdWedingTimelineDate);
    const diffDays = Math.max(weddingDay.diff(createdWedingTimelineDay, 'day'), 0);
    return diffDays;
  }, [weddingDate, createdWedingTimelineDate]);

  const percentage = useMemo(() => {
    return Math.max(1, Math.min(100, ((totalDays - remainingDays) / totalDays) * 100));
  }, [remainingDays, totalDays]);

  if (!weddingDate) return null;

  return (
    <div className="progress-container">
      <div className="label-container">
        <span>Just Started</span>
        <span>Your Big Day</span>
      </div>

      <div className="progress-bar">
        <div className="progress-bar-fill" style={{ width: `${percentage}%` }}></div>
      </div>

      <div className="remaining-days-container">
        <div className="remaining-days">
          <span>{remainingDays}</span>
          <span>&nbsp;days until your wedding</span>
        </div>
      </div>
    </div>
  )
}

export default ChatbotWeddingDateProgress;